export default __webpack_public_path__ + "media/event-footer.24c0446c.png";